// The payload is an object, never a bare id: synapse's `DefaultPayload` requires a record.
export type InterviewDeletedPayload = {
	interviewId: number;
};

export type InterviewDeletedAction = {
	type: 'INTERVIEW_DELETED';
	payload: InterviewDeletedPayload;
	facilityId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: InterviewDeletedPayload,
	facilityId: number,
	typeKey: string,
	subjectId: number,
): InterviewDeletedAction => ({
	type: 'INTERVIEW_DELETED',
	payload,
	facilityId,
	typeKey,
	subjectId,
});
